module.exports = __webpack_public_path__ + "img/mode-01.f631792c.png";